// variant-color-restore.js

// 日本語カラー名 → 実際の色。aria-labelから色名を読み取ってbackground-colorを
// 補修するための対応表(既存のcolorMapをそのまま切り出したもの、内容は変更なし)。
const SWATCH_COLOR_MAP = {
  'レッド': '#ff4444', 'ダークブラウン': '#5b3a29', 'ホワイト': '#efefef', 'ナチュラル': '#e5dbca',
  'ブラック': '#000000', 'ベージュ': '#e5dbca', 'グレー': '#cccccc'
};

// 色復元処理(既存ロジックはそのまま、対象範囲だけrootで受け取れるようにした関数)。
// root=documentで呼べば従来通りページ全体が対象になる。
// Recommended Productsのように後からDOMに追加されるコンテナに対しては、
// そのコンテナ要素をrootとして渡すことで同じ処理を再実行できる。
function restoreSwatchColors(root) {
  root.querySelectorAll('.variant-option, .product__color-swatch, li.product-swatches-options__item--swatch, [data-variant-option]').forEach(el => {
    const label = el.getAttribute('aria-label');
    // 例: "色 ブラック" / "ブラック/ダークブラウン" / "ブラック｜2月下旬頃発送予定" など、
    // 区切り文字(-, ｜, / …)や発送予定日の有無・書式は商品によってまちまち。
    // 区切り文字を推測して分割するのではなく、SWATCH_COLOR_MAPに登録済みの色名が
    // label内のどこかに含まれているかで判定する(区切り文字の変化に影響されない)。
    if (!label) return;

    // 複数の色名が含まれる場合(例:「ブラック/ダークブラウン」)は、
    // 元のロジックと同じく label 内でより後方に出てくる方を優先する。
    let colorName = null;
    let lastIndex = -1;
    Object.keys(SWATCH_COLOR_MAP).forEach(name => {
      const idx = label.lastIndexOf(name);
      if (idx > lastIndex) {
        lastIndex = idx;
        colorName = name;
      }
    });

    if (colorName) {
      el.style.backgroundColor = SWATCH_COLOR_MAP[colorName];
      el.style.color = (colorName === 'ホワイト') ? '#333' : '#fff';
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // 1. 既存のカラー復元処理（挙動は変更なし。ページ全体(document)に対して1回実行）
  restoreSwatchColors(document);

  // 1-b. 新設: Recommended Productsは中身がXMLHttpRequestで非同期取得されて
  //   後からDOMに追加されるため、上のrestoreSwatchColors(document)のタイミングには
  //   間に合わない。そのコンテナだけを監視し、中身が追加されたら同じ処理を
  //   そのコンテナに対してだけ再実行する。
  //   (カート・コレクションページにはこのセレクタに一致する要素が存在しないため、
  //   それらのページの挙動には影響しない)
  document.querySelectorAll('[data-section-type="recommended-products"] [data-recommendations]').forEach(container => {
    const observer = new MutationObserver(() => {
      restoreSwatchColors(container);
    });
    observer.observe(container, { childList: true, subtree: true });
  });

  // 2. 新設: プルダウン連動フィルタ関数
  function filterSwatchesBySelect() {
    const select = document.querySelector('select[id*="option2"]');  // 対象プルダウン
    if (!select) return;

    const selectedText = select.options[select.selectedIndex].text.trim();  // 選択テキスト取得
    const swatchItems = document.querySelectorAll('div.product__color-swatches--inner.dynamic-variant-input-wrap button');

    swatchItems.forEach(swatch => {
      const ariaLabel = swatch.getAttribute('aria-label') || '';
      if (ariaLabel.includes(selectedText)) {
        swatch.style.display = 'block';  // 一致→表示
      } else {
        swatch.style.display = 'none';   // 非一致→非表示
      }
    });

    // 表示中swatchを自動クリック（最初のを選択）
    const visibleSwatch = document.querySelector('div.product__color-swatches--inner.dynamic-variant-input-wrap button[style*="block"]');
    if (visibleSwatch) {
      visibleSwatch.click();
    }
  }

  // 3. プルダウン変更イベント監視
  document.querySelectorAll('select[id*="option2"]').forEach(select => {
    select.addEventListener('change', filterSwatchesBySelect);
  });

  // ページロード時も1回実行
  filterSwatchesBySelect();
});
